/**
 * @deprecated use same function from '@alilc/lowcode-utils' instead
 */
export function isProjectSchema(data) {
  return data && data.componentsTree;
}